export default (values) => {
  const errors = {
    theme: {},
  };

  if (!values?.name) errors.name = true;
  if (!values?.theme?.main_color) errors.main_color = true;
  if (!values?.theme?.button_color) errors.button_color = true;

  return errors;
};
